import React, {useCallback, useEffect, useState} from 'react';
import {BaseConfig} from 'config';
import {CustomerConfig} from 'config/entity/BaseConfigInterface';
import {JobMenuItem} from 'shared/components/Header/JobMenuItem';
import {useAppContext} from 'contexts';
import {urlPartsJob} from 'shared/helpers';
import {useResizeObserver} from 'shared/helpers/useResizeObserver';

type JobMenu = CustomerConfig['jobMenu'][number];

interface MobileMenuProps {
    onHeightChange?: (height?: number) => void;
}

export const MobileMenu = ({onHeightChange}: MobileMenuProps) => {
    const {userLevel, isMobileMenuVisible} = useAppContext();
    const [jobMenu, setJobMenu] = useState<JobMenu[]>([]);
    const [jobId] = urlPartsJob() as string[];

    const isVisible = !!jobId && !!isMobileMenuVisible;

    const handleResize = useCallback(
        (
            entries: ResizeObserverEntry[],
            container: React.MutableRefObject<HTMLDivElement>
        ) => {
            const menu = container.current;

            // only update the state for when menu is not expanded
            if (menu.querySelector('[data-expanded="true"]')) return;

            onHeightChange?.(menu.getBoundingClientRect().height);
        },
        [onHeightChange]
    );

    const menuRef = useResizeObserver(handleResize);

    useEffect(() => {
        if (!isVisible) return;

        return () => onHeightChange?.(undefined);
    }, [isVisible, onHeightChange]);

    useEffect(() => {
        if (userLevel === 'USER_CUSTOMER') {
            const menu = BaseConfig.USER_CUSTOMER.jobMenu.filter(
                (menuItem) =>
                    typeof menuItem.isVisibleMobile === 'undefined' ||
                    menuItem.isVisibleMobile
            );

            menu.sort(
                (first, second) => first.orderMobile - second.orderMobile
            );

            setJobMenu(menu);
        } else {
            setJobMenu([]);
        }
    }, [userLevel]);

    if (isVisible) {
        return (
            <div className="mobile-menu" id="mobile-menu" ref={menuRef}>
                <JobMenuItem jobMenu={jobMenu} isCollapsed={false} />
            </div>
        );
    }

    return null;
};
